<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode conferir todos os colaboradores vinculadas à
              empresa até o momento. Toda nova conta criada aparecerá
              automaticamente na tabela abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-12">
          <div
            class="card shadow table-container vld-parent"
            ref="colaboradores_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    Lista de <span class="text-orange">colaboradores</span>
                    <span
                      v-tooltip="
                        tableData.length >= max_collaborators
                          ? 'O número limite de acessos para colaboradores foi atigindo. Contate o suporte em caso de dúvidas.'
                          : 'Clique para cadastrar uma nova conta de colaborador'
                      "
                      class="float-right"
                    >
                      <base-button
                        :disabled="tableData.length >= max_collaborators"
                        :custom="true"
                        size="sm"
                        type="primary"
                        @click="$router.push('/empresa/colaboradores/novo')"
                        ><i class="fas fa-plus mr-1"></i> Cadastrar
                        colaborador</base-button
                      ></span
                    >
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="tableData"
                type="hover"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Colaborador</th>
                  <th>Status da conta</th>
                  <th>Email usuário</th>
                  <th>Telefone</th>
                  <th>Cargo/Posição</th>
                  <th>Localização</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td class="py-4">{{ index + 1 }}</td>
                  <th scope="row">
                    <router-link
                      :to="`/empresa/colaboradores/${row.user.id}/editar`"
                      class="btn btn-link p-0 m-0"
                    >
                      {{ row.name }}
                    </router-link>
                  </th>
                  <td>
                    <div class="mt-1">
                      <badge
                        v-if="row.account_validated"
                        type="success"
                        v-tooltip="'A conta do colaborador está validada.'"
                      >
                        <i class="fas fa-info-circle mr-1"></i>
                        Conta validada
                      </badge>
                      <badge
                        v-else
                        type="warning"
                        v-tooltip="
                          'Enquanto a conta não for validada o colaborador não terá acesso as funcionalidades do portal.'
                        "
                      >
                        <i class="fas fa-info-circle mr-1"></i>
                        Conta não validada
                      </badge>
                    </div>
                  </td>
                  <td>
                    <email-link
                      :emailAddress="row.user.email"
                      :showLeftMailIcon="false"
                    />
                  </td>
                  <td>
                    <whatsapp-link
                      :phoneNumber="row.phone"
                      :showLeftPhoneIcon="false"
                    />
                  </td>
                  <td>
                    {{ row.position || "-" }}
                  </td>
                  <td>
                    <span
                      v-tooltip="
                        row.neighborhood
                          ? `Bairro: ${row.neighborhood}` +
                            (row.street
                              ? ` - Rua: ${row.street}` +
                                (row.street_number
                                  ? `,  ${row.street_number}`
                                  : '')
                              : '')
                          : ''
                      "
                      >{{ row.city }}, {{ row.state }}</span
                    >
                  </td>
                  <td>
                    <router-link
                      :to="'/empresa/colaboradores/' + row.user.id + '/editar'"
                      v-tooltip.bottom="'Editar colaborador'"
                      class="btn btn-white py-1 px-2"
                    >
                      <i class="fas fa-edit text-info"></i>
                    </router-link>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Não há colaboradores cadastrados até o momento
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!empty" class="row">
        <div class="col-12 text-muted text-right mt-4">
          <b>{{ tableData.length }}</b> colaboradores de
          <span
            v-tooltip="'Máximo de colaboradores vinculados à conta da empresa'"
            ><b>{{ max_collaborators }}</b> colaboradores</span
          >
          cadastrados ao total
        </div>
        <div class="col-12 text-right">
          <hr class="mt-3 mb-1" />
          <base-button
            type="link"
            :custom="true"
            @click="$router.push('/empresa/colaboradores')"
            >Visualizar como lista</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "colaboradores_table",
  data() {
    return {
      tableData: [],
      max_collaborators: "",
      empty: false,
      modals: {
        modalConfirmation: false,
        colaboradorName: "",
        colaboradorEmail: "",
        colaboradorId: null
      }
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.colaboradores_table,
      width: 90,
      height: 90
    });
    try {
      const { data } = await api.get("/company/collaborators");
      if (data.collaborators.length) this.tableData = data.collaborators;
      else this.empty = true;
      this.max_collaborators = data.max_collaborators;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os colaboradores");
    }
  }
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
</style>
